import { render, staticRenderFns } from "./BasicNoticeList.vue?vue&type=template&id=75204bb9&scoped=true"
import script from "./BasicNoticeList.vue?vue&type=script&lang=js"
export * from "./BasicNoticeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75204bb9",
  null
  
)

export default component.exports